import { staticMemo } from "core/utils";
import last from "lodash/last";
import take from "lodash/take";
import "./breadcrumb.scss";

interface BreadcrumProps {
	path: string[];
}

const toBreadcrumbItem = (item: string, index: number) => (
	<li key={index} className="breadcrumb-item"><p>{item}</p></li>
);

const Breadcrumb = staticMemo((props: BreadcrumProps) => {
	const currentPage = last(props.path) ?? "NA";
	const parents = take(props.path, props.path.length - 1);

	return (
		<nav style={{ fontFamily: "GothamMedium", fontSize: 14 }}>
			<ol className="breadcrumb">
				{parents.map(toBreadcrumbItem)}
				<li className="breadcrumb-item active" aria-current="page">{currentPage} &gt;</li>
			</ol>
		</nav>
	);
});

export default Breadcrumb;